import { useAuth } from "./auth/index.mjs";
import { sleep } from "../utils/async.mjs";
import { computed } from "vue";
export function useSsrCoreApp(isFetchingDeps) {
  const { isPendingAuth } = useAuth();
  const isServer = computed(() => process.server);
  const isPageLoading = computed(() => {
    if (isServer.value) return true;
    return isPendingAuth.value || isFetchingDeps?.some((dep) => dep.value);
  });
  async function waitForPageToBeLoaded() {
    while (isPageLoading.value) {
      await sleep(200);
    }
  }
  return {
    isPageLoading,
    isServer,
    waitForPageToBeLoaded
  };
}
